import { render, staticRenderFns } from "./LivraisonsPage.vue?vue&type=template&id=44e75439&"
import script from "./LivraisonsPage.vue?vue&type=script&lang=js&"
export * from "./LivraisonsPage.vue?vue&type=script&lang=js&"
import style0 from "./LivraisonsPage.vue?vue&type=style&index=0&id=44e75439&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports